/**
  * 登录 接口的统一出口
  */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

const api = '/c-api/'

const appVersionset = {
    // 查询
    index (params) {
        return axios.get(api + 'appVersionset/index', { params: params })
    },
    // 修改
    edit (params) {
        return axios.post(api + 'appVersionset/edit', qs.stringify(params))
    }
}

// 导出接口
export default appVersionset
